// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CItO","label":"styles_label__3hmn4"};